import { Pipe, PipeTransform } from '@angular/core';
import { formatFutureRelativeTime } from '../components/job-admin/job-admin-labels';

@Pipe({
  name: 'formatFutureRelativeTime'
})
export class FutureRelativeTimePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return formatFutureRelativeTime(value);
  }
}
